import { AttendanceFilterOptionValue, FilterKey } from '@studyportals/search-filters';
import { FilterOptionInformation } from '@studyportals/search-filters';
import { FilterOptionsBase } from './FilterOptionsBase';

export class AttendanceOptionsForDistanceLearning extends FilterOptionsBase {
	public override getFilterKey(): FilterKey {
		return FilterKey.DELIVERY_METHOD;
	}

	public override createOptions(): FilterOptionInformation[] {
		return [
			new FilterOptionInformation('Fully online', AttendanceFilterOptionValue.ONLINE, 'online', 'Online', 'Online'),
			new FilterOptionInformation('Blended', AttendanceFilterOptionValue.BLENDED, '', '', 'Blended'),
		];
	}

	public override isRequired(): boolean {
		return true;
	}
}
